window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

/* ------------------------------------------------------------------
   THE OLD CLUB MINIMUM WAS REMOVED FROM THIS FILE ON 2026-08-21.

   It defined its own minimums, keyed by bundle and variant:

     Cave Collector  675
     Wine Vault     1770
     Cellar Master  3660

   and printed "Minimum price of $675 is required for this club." into the
   builder footer, then toggled a priceNotMet class on click.

   THOSE THREE FIGURES WERE NEVER POLICY. They were each tier's default box
   total. The real minimums are 550 / 1500 / 3000, confirmed by Justin from
   Patricia on 2026-08-21, and they live in assets/skipstone-tiers.js.

   Both were running at once. Two definitions of the same rule, disagreeing,
   four days before 711 members bill. A member reading the footer saw the wrong
   number, and the old listeners kept firing underneath the new guard.

   The guard that remains is in assets/skipstone-portal.js. It reads its
   figures from skipstone-tiers.js, which is now the only place a club minimum
   is written down.

   WHAT WAS DELETED, precisely, so this can be reversed from git if needed:
     - the babMinimums object
     - the waitForElement(".bundle-table__body-row--bab-parent", ...) block in
       the customer-portal branch, and its checkBabEdit listeners
     - the if (babMinimums[bundleId]) { ... } block in the build-a-box branch

   WHAT WAS DELIBERATELY KEPT, because other things depend on it:
     - every document.body.classList.add(...) call. body.awt-cp in particular
       is what all of skipstone-portal.css is scoped to. Removing it would
       unstyle the entire customer portal.
     - window.Awtomic.getBabSelection
     - the cart rollup handler
     - waitForElement itself, now unused here but left in place rather than
       widening the diff.
   ------------------------------------------------------------------ */

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic allocation page like https://kpvjpx-he.myshopify.com/tools/bundle-subscriptions/allocation/265
if (window.location.pathname.includes("/tools/bundle-subscriptions/allocation/")) {
  document.body.classList.add("awt-allocation");
  const allocationId = window.location.pathname.split("/").pop();
  if (allocationId) {
    document.body.classList.add(`awt-allocation-${allocationId}`);
  }
}

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  const urlParts = window.location.pathname.split("/");
  const bundleId = urlParts[urlParts.length - 1];
  if (bundleId) {
    document.body.classList.add(`awt-bundle-${bundleId}`);
  }
}

//cart rollup
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});
